import { useToken } from "wagmi";
import { Token } from "@form/types";
import { isValidAddress } from "@form/utils/validate";

export default function useERC20Info(address?: string, chain?: number) {
  const isValid = isValidAddress(address || "") && !!chain;
  const { data, isLoading, error } = useToken({
    address: address as any,
    chainId: chain,
    enabled: isValid,
  });

  return {
    info: {
      ...data,
      chainId: chain,
    } as Token,
    isLoading,
    error,
  };
}
